import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../sheet/bottom-sheet/index.esm.js';
import '../../sheet/popover-sheet/index.esm.js';
import '../../sheet/side-sheet/index.esm.js';
import '../../sheet/centered-sheet/index.esm.js';
import '../../sheet/full-sheet/index.esm.js';
import '../../sheet/sheet/index.esm.js';
import { EGDSSheetContent } from '../../sheet/sheet-content/index.esm.js';
import '../../sheet/sheet-close-button/index.esm.js';
import '../../sheet/sheet-transition/index.esm.js';
import '../../sheet/sheet-footer/index.esm.js';
import '../../sheet/types/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-dialog.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSDialogContent extends React.PureComponent {
  static displayName = 'EGDSDialogContent';
  render() {
    const {
      children,
      className,
      contentDomRef,
      zeroPadding
    } = this.props;
    const wrapperClassNames = getClassNameList('uitk-dialog-content', className, {
      'default-padding': !zeroPadding
    });
    return jsx(EGDSSheetContent, {
      className: wrapperClassNames,
      padded: !zeroPadding,
      contentDomRef: contentDomRef,
      children: children
    });
  }
}
export { EGDSDialogContent };